var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4181_15316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2786 1.94033C16.4549 0.795962 14.2994 0.131836 11.9875 0.131836C9.67557 0.131836 7.52013 0.795962 5.69661 1.94033C2.3557 4.03703 0.132812 7.75124 0.132812 11.9865C0.132812 16.2218 2.3557 19.936 5.69661 22.0327C7.52013 23.1771 9.67557 23.8412 11.9875 23.8412C14.2994 23.8412 16.4549 23.1771 18.2786 22.0327C21.6196 19.936 23.8422 16.2218 23.8422 11.9865C23.8422 7.75124 21.6196 4.03703 18.2786 1.94033Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.2082 11.6546L20.1993 11.6466L19.9095 10.7062L19.5881 11.6651L18.6055 11.6493L19.4169 12.2499L19.0981 13.1799L19.92 12.5924L20.7077 13.1851L20.4021 12.2209L21.2082 11.6546Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0317 9.19931L18.8536 8.61448L19.6413 9.20458L19.3357 8.2404L20.1418 7.67665L19.1329 7.66611L18.8431 6.72827L18.5243 7.68455L17.5391 7.66874L18.3505 8.26938L18.0317 9.19931Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0104 3.85425L15.6916 4.81316L14.709 4.79735L15.5177 5.39536L15.2016 6.32793L16.0209 5.74046L16.8086 6.33056L16.5056 5.36901L17.3091 4.80262L16.3001 4.79472L16.0104 3.85425Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0299 2.7478L11.7111 3.70408L10.7285 3.68827L11.5399 4.28891L11.2211 5.21885L12.0404 4.63402L12.8281 5.22412L12.5252 4.26257L13.3286 3.69618L12.3223 3.68564L12.0299 2.7478Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09112 3.8147L7.77237 4.77098L6.78711 4.75517L7.5985 5.35581L7.27974 6.28574L8.10166 5.70091L8.88934 6.29101L8.58639 5.32946L9.38987 4.76307L8.38091 4.75254L8.09112 3.8147Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.138 6.68616L4.81661 7.64244L3.83398 7.62663L4.64537 8.22727L4.32661 9.15984L5.14854 8.57237L5.93622 9.16247L5.63063 8.20092L6.43675 7.63453L5.42778 7.62663L5.138 6.68616Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.08213 12.553L4.86981 13.1431L4.56422 12.1815L5.37034 11.6151L4.36137 11.6072L4.07159 10.6667L3.7502 11.623L2.76758 11.6072L3.57897 12.2079L3.26021 13.1404L4.08213 12.553Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42778 15.6694L5.138 14.7289L4.81661 15.6852L3.83398 15.6694L4.64537 16.27L4.32661 17.1999L5.14854 16.6151L5.93622 17.2052L5.63063 16.2436L6.43675 15.6773L5.42778 15.6694Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29887 18.6225L8.00909 17.682L7.6877 18.6383L6.70508 18.6251L7.51647 19.2231L7.19771 20.1557L8.01963 19.5682L8.80731 20.1583L8.50172 19.1968L9.30784 18.6304L8.29887 18.6225Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2793 19.6895L11.9896 18.749L11.6682 19.7079L10.6855 19.6921L11.4969 20.2928L11.1782 21.2227L12.0001 20.6352L12.7878 21.2253L12.4822 20.2638L13.2883 19.6974L12.2793 19.6895Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.2598 18.6225L15.97 17.682L15.6486 18.6383L14.666 18.6251L15.4774 19.2231L15.1586 20.1557L15.9806 19.5682L16.7682 20.1583L16.4627 19.1968L17.2688 18.6304L16.2598 18.6225Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2129 15.6694L18.9232 14.7289L18.6044 15.6852L17.6191 15.6694L18.4305 16.27L18.1118 17.1999L18.9337 16.6151L19.7214 17.2052L19.4184 16.2436L20.2219 15.6773L19.2129 15.6694Z",
    fill: "#FFDA44"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4181_15316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEur);
export default __webpack_public_path__ + "static/media/EUR.74b57d1f4a8dd902911d9ad654b7a00c.svg";
export { ForwardRef as ReactComponent };